export default "__VITE_ASSET__18d58bea__"